import Swiper from "swiper";
import SwiperElement from "../molecules/SwiperElement";
import {Tracking} from "../../tracking/tracking";

/**
 * Product swiper on blog entry pages (LongText in TextPLaceholder Template)
 * Old design class: .swiper-products
 * Redesign class: .swiper-products-redesign
 */
const slideSpacing = 16;
const lazyPreload = [2, 3, 4, 4];
const slidesPerView = [1.6, 2.6, 3.6, 4];

const swiperTeaserParams = {
  breakpoints: {
    0: {
      slidesOffsetBefore: slideSpacing,
      slidesPerView: slidesPerView[0],
    },
    480: {
      slidesOffsetBefore: slideSpacing,
      slidesPerView: slidesPerView[1],
    },
    767: {
      slidesOffsetBefore: slideSpacing,
      slidesPerView: slidesPerView[2],
    },
    1119: {
      slidesOffsetBefore: 0,
      slidesPerView: slidesPerView[3],
    },
  },
  lazy: {
    loadPrevNext: true,
    loadPrevNextAmount: 3,
  },
  loop: true,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  observer: true,
  on: {
    init,
    slideChange,
  },
  preloadImages: false,
  slidesOffsetBefore: 0,
  slidesPerView: slidesPerView[3],
  spaceBetween: slideSpacing,
};

const swiperTeaserParamsRedesign = {
  navigation: {
    nextEl: ".swiper-products-redesign .swiper-btn-next",
    prevEl: ".swiper-products-redesign .swiper-btn-prev",
  },
  lazyPreloadPrevNext: lazyPreload[0],
  slidesOffsetBefore: slideSpacing,
  slidesOffsetAfter: slideSpacing,
  slidesPerView: slidesPerView[0],
  spaceBetween: slideSpacing,
  createElements: true,
  breakpoints: {
    481: {
      lazyPreloadPrevNext: lazyPreload[1],
      slidesPerView: slidesPerView[1],
    },
    768: {
      lazyPreloadPrevNext: lazyPreload[2],
      slidesPerView: slidesPerView[2],
    },
    1132: {
      lazyPreloadPrevNext: lazyPreload[3],
      slidesOffsetBefore: 0,
      slidesOffsetAfter: 0,
      slidesPerView: slidesPerView[3],
      rewind: true,
    },
  },
};

export class TeaserSwiper {
  private readonly swiperDiv: HTMLDivElement;

  constructor(swiperDiv: HTMLDivElement) {
    this.swiperDiv = swiperDiv;
    const _ = new Swiper(this.swiperDiv, swiperTeaserParams);
    _.loaded = true;
  }
}

export class TeaserSwiperRedesign {
  public static run(section: HTMLDivElement): void {
    const navigationButtons: HTMLElement | null = section.querySelector(".swiper-navigation");
    if (navigationButtons !== null) {
      navigationButtons.style.display = "";
    }

    SwiperElement.run(section, swiperTeaserParamsRedesign);
  }
}

function init() {
  Array.from<HTMLDivElement>(this.slides).forEach((slide) => {
    const anchor = slide.querySelector("a") as HTMLAnchorElement;
    anchor.addEventListener("click", (evt: Event) => {
      Tracking.sendEvent("BlogEntry.ProductSwiper.Slide.Clicked");
    });
  });
}

function slideChange() {
  if (this.loaded) {
    Tracking.sendEvent("BlogEntry.ProductSwiper.Swiped");
  }
}
